import { api } from '@/lib/api';
import type { AccDashboardResponse } from './types';

/**
 * Fetch the bookkeeper dashboard payload from the BFF.
 * All sections are independently degradable — a failing section returns null
 * and its key appears in `degraded[]`.
 */
export async function getAccDashboard(): Promise<AccDashboardResponse> {
  return api.get<AccDashboardResponse>('/v4/acc-dashboard');
}

/**
 * Mark a review-queue exception as resolved.
 */
export async function resolveException(
  id: string,
  body: { reason?: string },
): Promise<void> {
  await api.post(`/v4/acc-exceptions/${id}/resolve`, body);
}

/**
 * Dismiss a review-queue exception (requires confirmation from caller).
 */
export async function dismissException(
  id: string,
  body: { reason?: string },
): Promise<void> {
  await api.post(`/v4/acc-exceptions/${id}/dismiss`, body);
}
